var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-rep-remarks" },
    [
      _c("label", [_vm._v(_vm._s(_vm.$t("comments")))]),
      _vm._v(" "),
      _c("HKLInput", {
        model: {
          value: _vm.remarksContent,
          callback: function ($$v) {
            _vm.remarksContent = $$v
          },
          expression: "remarksContent",
        },
      }),
      _vm._v(" "),
      _c("HKLButton", {
        attrs: { color: "orange", action: "review" },
        on: {
          click: function () {
            return _vm.remarkReview()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }